module.exports = __webpack_public_path__ + "img/3.679ab810.jpg";